import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { ExternalLink, Icon, SocialWrap } from './index.styled'

const Social = () => {
  const {
    dataJson: {
      footerInfo: { socialLinks }
    }
  } = useStaticQuery(graphql`
    query {
      dataJson {
        footerInfo {
          socialLinks {
            type
            link
          }
        }
      }
    }
  `)

  return (
    <SocialWrap>
      {socialLinks.map((l, i) => {
        return (
          <ExternalLink
            key={`links-social-${i}`}
            href={l.link}
            target='_blank'
            rel='noreferrer'
          >
            <Icon className={l.type} />
          </ExternalLink>
        )
      })}
    </SocialWrap>
  )
}

export default Social
